import { IEmployeeInfo } from 'shared/api/business/interfaces/employee-info.interface';

export class validateInputs {
  public static validateFullName(fullName: string) {
    const trimmedFullName = fullName.trim();
    const regexFullName = /^[a-zA-Zа-яА-ЯёЁ\s]+$/;
    const words = trimmedFullName.split(' ');

    if (words.length !== 3 || !regexFullName.test(trimmedFullName)) {
      return false;
    }
    for (const word of words) {
      if (word.length < 2) {
        return false;
      }
    }
    return true;
  }

  public static validateMail(email: string) {
    const regexMail =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (!email || !regexMail.test(email)) {
      return false;
    }
    return true;
  }
  public static validatePrice(price: string) {
    const regexPrice = /^\d+$/;

    if (!price || !regexPrice.test(price)) {
      return false;
    }
    return true;
  }

  public static validatePhone(phone: string) {
    const regexPhone = /^(?:7|8)\d{10}$/;

    if (!phone || !regexPhone.test(phone)) {
      return false;
    }
    return true;
  }
  public static validatePassword(password: string) {
    if (!password || password.length < 8 || password.length > 16) {
      return false;
    }
    return true;
  }
  public static validateConfirmPassword(
    password: string,
    confirmPassword: string
  ) {
    if (password !== confirmPassword) {
      return false;
    }
    return true;
  }
  public static validateBusinessName(name: string) {
    if (!name) {
      return false;
    }
    return true;
  }
  public static validateServiceName(name: string) {
    if (!name) {
      return false;
    }
    return true;
  }
  public static validateServiceCategory(category: string) {
    if (!category) {
      return false;
    }
    return true;
  }
  public static validateServiceDuration(duration: string) {
    if (Number(duration) == 0) {
      return false;
    }
    return true;
  }
  public static validateServiceEmployees(employees: IEmployeeInfo[]) {
    if (!employees) {
      return false;
    }
    return true;
  }

  public static validateBusinessAddress(address: string) {
    if (!address) {
      return false;
    }
    return true;
  }
  public static validateLink(link: string) {
    if (link === '') {
      return true;
    }
    const regexLink =
      /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;

    if (!regexLink.test(link)) {
      return false;
    }
    return true;
  }
  public static validateDescription(description: string) {
    const trimmedDescription = description.trim();

    if (trimmedDescription.length >= 100) {
      return false;
    }
    return true;
  }
}
